const SCROLLING_CLASS = 'is-scrolling';
const HIDE_DELAY_MS = 1200;

/** Sets up a global scroll listener that toggles a CSS class to auto-hide scrollbars after inactivity */
export function initAutoHideScrollbars(): void {
  const timers = new WeakMap<Element, ReturnType<typeof setTimeout>>();

  document.addEventListener('scroll', (event: Event) => {
    const target = event.target as Element | null;
    if (!target || !(target instanceof Element)) {
      return;
    }

    target.classList.add(SCROLLING_CLASS);

    const existing = timers.get(target);
    if (timers.has(target)) {
      clearTimeout(existing);
    }

    timers.set(target, setTimeout(() => {
      target.classList.remove(SCROLLING_CLASS);
      timers.delete(target);
    }, HIDE_DELAY_MS));
  }, {capture: true, passive: true});
}
